import { getCountries } from 'libphonenumber-js'
import codes from 'country-calling-code'

const countries = getCountries()

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })

export const getCountriName = (code: string) => {
  return regionNames.of(code)
}

export const COUNTRIES = countries
  .map((code) => {
    const country = {
      code,
      name: getCountriName(code),
      callingCode:
        '+' + codes.find((c) => c.isoCode2 === code)?.countryCodes[0],
    }

    return country
  })
  .filter((country) => country.name && country.callingCode !== '+undefined')

export const getFlagEmoji = (countryCode: string) => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0))
  return String.fromCodePoint(...codePoints)
}

export const getCountryByCode = (code: string) =>
  COUNTRIES.find((country) => country.code === code)
